module.exports = __webpack_public_path__ + "img/20191220151950574.d8c21bad.jpg";